module.exports = "<mat-spinner [diameter]=\"50\"></mat-spinner>\n<span class=\"percentage\">{{percentage}}</span>\n<span class=\"message\">{{message}}</span>\n"